(() => {
  const body = document.body;

  const setExpanded = (trigger, expanded) => {
    if (trigger) trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  };

  const mobileToggle = document.querySelector('[data-mobile-menu-toggle]');
  const nav = document.querySelector('[data-main-nav]');
  if (mobileToggle && nav) {
    mobileToggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      setExpanded(mobileToggle, open);
    });
  }

  const overlay = document.querySelector('[data-drawer-overlay]');
  const drawer = document.querySelector('[data-cart-drawer]');
  const drawerBody = document.querySelector('[data-cart-drawer-body]');
  const drawerTotal = document.querySelector('[data-cart-drawer-total]');
  const cartButtons = document.querySelectorAll('[data-cart-open]');
  const cartClose = document.querySelector('[data-cart-close]');

  const money = (cents) => {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: window.PickNexaCurrency || 'USD'
    }).format(cents / 100);
  };

  const updateCartCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count < 1;
    });
  };

  const renderCart = (cart) => {
    updateCartCount(cart.item_count);
    if (!drawerBody || !drawerTotal) return;

    if (!cart.items.length) {
      drawerBody.innerHTML = '<p>Your bag is waiting for something lovely.</p>';
      drawerTotal.textContent = money(0);
      return;
    }

    drawerBody.innerHTML = cart.items.map((item) => {
      const image = item.featured_image
        ? `<img src="${item.featured_image.url}" alt="${item.featured_image.alt || item.product_title}">`
        : '<div class="pn-cart-line-image"></div>';
      return `<article class="pn-cart-line">
        ${image}
        <div><h3>${item.product_title}</h3><p>${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''}</p><p>Qty: ${item.quantity}</p></div>
        <strong>${money(item.final_line_price)}</strong>
      </article>`;
    }).join('');
    drawerTotal.textContent = money(cart.total_price);
  };

  const refreshCart = async () => {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart request failed');
      const cart = await response.json();
      renderCart(cart);
      return cart;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const openDrawer = async () => {
    await refreshCart();
    drawer?.classList.add('is-open');
    overlay?.classList.add('is-open');
    body.classList.add('drawer-open');
    setExpanded(document.querySelector('[data-cart-open]'), true);
    cartClose?.focus();
  };

  const closeDrawer = () => {
    drawer?.classList.remove('is-open');
    overlay?.classList.remove('is-open');
    body.classList.remove('drawer-open');
    setExpanded(document.querySelector('[data-cart-open]'), false);
  };

  cartButtons.forEach((button) => button.addEventListener('click', openDrawer));
  cartClose?.addEventListener('click', closeDrawer);
  overlay?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeDrawer();
      nav?.classList.remove('is-open');
      setExpanded(mobileToggle, false);
    }
  });

  document.querySelectorAll('[data-quick-add]').forEach((button) => {
    button.addEventListener('click', async () => {
      const original = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding…';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] })
        });
        if (!response.ok) throw new Error('Unable to add item');
        button.textContent = 'Added';
        await openDrawer();
      } catch (error) {
        button.textContent = 'Try again';
        console.error(error);
      } finally {
        setTimeout(() => {
          button.textContent = original;
          button.disabled = false;
        }, 1400);
      }
    });
  });

  document.querySelectorAll('[data-product-tabs]').forEach((tabs) => {
    const section = tabs.closest('[data-product-section]');
    const cards = section?.querySelectorAll('[data-product-kind]') || [];
    tabs.querySelectorAll('[data-filter]').forEach((button) => {
      button.addEventListener('click', () => {
        tabs.querySelectorAll('[data-filter]').forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');
        const filter = button.dataset.filter;
        cards.forEach((card) => {
          card.hidden = filter !== 'all' && card.dataset.productKind !== filter;
        });
      });
    });
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const select = form.querySelector('[data-variant-select]');
    const price = form.querySelector('[data-product-price]');
    if (!select || !price) return;
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      price.textContent = option.dataset.price || price.textContent;
    });
  });
})();


/* Customer colour theme picker */
(() => {
  const picker = document.querySelector('[data-theme-picker]');
  if (!picker) return;
  const toggle = picker.querySelector('[data-theme-toggle]');
  const panel = picker.querySelector('[data-theme-panel]');
  const close = picker.querySelector('[data-theme-close]');
  const choices = [...picker.querySelectorAll('[data-theme-choice]')];
  const palettes = ['sage', 'rose', 'lavender', 'ocean', 'cocoa'];
  const setOpen = (open) => {
    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  };
  const apply = (palette) => {
    const selected = palettes.includes(palette) ? palette : 'sage';
    document.documentElement.dataset.pnPalette = selected;
    choices.forEach((choice) => choice.setAttribute('aria-checked', choice.dataset.themeChoice === selected ? 'true' : 'false'));
    try { localStorage.setItem('picknexa-palette', selected); } catch (error) {}
    const colour = getComputedStyle(document.documentElement).getPropertyValue('--pn-sage-dark').trim();
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', colour);
  };
  apply(document.documentElement.dataset.pnPalette);
  toggle.addEventListener('click', () => setOpen(panel.hidden));
  close?.addEventListener('click', () => { setOpen(false); toggle.focus(); });
  choices.forEach((choice) => choice.addEventListener('click', () => { apply(choice.dataset.themeChoice); setOpen(false); toggle.focus(); }));
  document.addEventListener('click', (event) => { if (!picker.contains(event.target)) setOpen(false); });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setOpen(false); });
})();
